import { expenseDao } from '@/service';
import ls from 'local-storage';

export default {
  state: { editingExpenseType: ls.get('editing_expense_type') || null },
  mutations: {
    setEditingExpenseType(state, type) {
      ls.set('editing_expense_type', type);
      state.editingExpenseType = type;
    },
  },
  actions: {
    async getAllExpenses(_, payload) {
      return new Promise((resolve, reject) => {
        expenseDao
          .getAll(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async getExpenses(_, payload) {
      return new Promise((resolve, reject) => {
        expenseDao
          .getExpenses(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async getExpense(_, payload) {
      return new Promise((resolve, reject) => {
        expenseDao
          .getOne(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async updateExpense(_, payload) {
      return new Promise((resolve, reject) => {
        expenseDao
          .update(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async saveExpense(_, payload) {
      return new Promise((resolve, reject) => {
        expenseDao
          .store(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    async updateExpenseInstallment(_, payload) {
      return new Promise((resolve, reject) => {
        expenseDao
          .updateExpenseInstallment(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    async destroyExpense(_, payload) {
      return new Promise((resolve, reject) => {
        expenseDao
          .destroyy(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    async deleteExpenseInstallment(_, payload) {
      return new Promise((resolve, reject) => {
        expenseDao
          .deleteExpenseInstallment(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async weekExpense(_, payload) {
      return new Promise((resolve, reject) => {
        expenseDao
          .weekExpense(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },

  getters: {
    editingExpenseType: (state) => state.editingExpenseType,
  },
};
